import { useMutation } from "@apollo/client";
import { gql } from "generated-graphql";

const REQUEUE_ACTIVITIES = gql(`
  mutation RequeueActivities($activityIds: [ID!]!, $comment: String) {
    requeueActivities(activityIds: $activityIds, comment: $comment) {
      activitiesUpdated
      updatedCount
    }
  }
`);

export const useRequeueActivities = () => {
  return useMutation(REQUEUE_ACTIVITIES, {
    refetchQueries: [
      "GetTierIIReport", // Fulfillment details for reports
      "GetCohort", // Fulfillment details for cohorts
      "GetAllWorkflowTags", // Tag picker autocomplete
    ],
  });
};
